module.exports = __webpack_public_path__ + "img/noData.7cf41917.svg";